import React from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "./permissionHelper";

const PermissionWrapper = ({ category, level = "VIEW_ONLY", children }) => {
  const permissionsData = useSelector(
    (state) => state.rolePermissionReducer.userPermissionData
  );

  const allowed = React.useMemo(
    () => hasPermission(permissionsData, category, level),
    [permissionsData, category, level]
  );

  if (!allowed) return null;

  return <>{children}</>;
};

export default PermissionWrapper;